/*
 * @Description:
 * @Author: tongjunyi<tongjunyi@didiglobal.com>
 * @Date: 2023-06-28 11:59:53
 * @LastEditors: tongjunyi
 * @LastEditTime: 2024-01-01 16:24:37
 */
import { RouteObject } from 'react-router-dom';
import { Suspense, lazy } from 'react';

const LazyImportComponent = (props: { lazyChildren: any }) => {
  return (
    <Suspense fallback={<></>}>
      <props.lazyChildren />
    </Suspense>
  );
};

const FuelOrder = lazy(() => import('@/pages/fuelOrder'));
const DlBill = lazy(() => import('@/pages/dlBill'));
const NoPermission = lazy(() => import('@/pages/noPermission'));
const DiscountSetting = lazy(() => import('@/pages/discountSetting'));
const DiscountRecord = lazy(() => import('@/pages/discountRecord'));
const SettlementBill = lazy(() => import('@/pages/settlementBill'));
const SettlementDetail = lazy(() => import('@/pages/settlementDetail'));
const Rating = lazy(() => import('@/pages/rating'));
const RatingDetail = lazy(() => import('@/pages/rating/ratingDetail'));

const ROUTER_CONFIG: RouteObject[] = [
  {
    path: '/noPermission',
    element: <LazyImportComponent lazyChildren={NoPermission} />
  },
  {
    path: '/fuelOrder',
    element: <LazyImportComponent lazyChildren={FuelOrder} />
  },
  {
    path: '/dlBill',
    element: <LazyImportComponent lazyChildren={DlBill} />
  },
  {
    path: '/discountSetting',
    element: <LazyImportComponent lazyChildren={DiscountSetting} />
  },
  {
    path: '/discountRecord',
    element: <LazyImportComponent lazyChildren={DiscountRecord} />
  },
  {
    path: '/settlementBill',
    element: <LazyImportComponent lazyChildren={SettlementBill} />
  },
  {
    path: '/settlementDetail',
    element: <LazyImportComponent lazyChildren={SettlementDetail} />
  },
  {
    path: '/order_rating',
    element: <LazyImportComponent lazyChildren={Rating} />
  },
  {
    path: '/ratingDetail',
    element: <LazyImportComponent lazyChildren={RatingDetail} />
  },
  {
    path: '*',
    element: <LazyImportComponent lazyChildren={NoPermission} />
  }
];

export { ROUTER_CONFIG };
